(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    // Validación del formulario
  document.addEventListener('DOMContentLoaded', function() {
    const contactForm = document.querySelector('#{{ form_id }}');
    
    if (contactForm) {
      // Agregar botón de enviar si no existe
      if (!contactForm.querySelector('[type="submit"]')) {
        const submitButton = document.createElement('button');
        submitButton.type = 'submit';
        submitButton.className = 'contact-form__submit';
        submitButton.textContent = 'Enviar mensaje';
        contactForm.appendChild(submitButton);
      }
      
      // Validación al enviar
      contactForm.addEventListener('submit', function(e) {
        const requiredFields = contactForm.querySelectorAll('[required]');
        let isValid = true;
        
        // Limpiar errores previos
        const existingError = contactForm.querySelector('.contact-form__error:not(.permanent)');
        if (existingError) {
          existingError.remove();
        }
        
        // Validar cada campo requerido
        requiredFields.forEach(function(field) {
          const fieldWrapper = field.closest('.contact-form__field');
          
          // Limpiar estilos de error previos
          field.style.borderColor = '';
          if (fieldWrapper) {
            const existingFieldError = fieldWrapper.querySelector('.field-error');
            if (existingFieldError) {
              existingFieldError.remove();
            }
          }
          
          // Validar checkbox
          if (field.type === 'checkbox' && !field.checked) {
            isValid = false;
            showFieldError(field, 'Debes aceptar la política de privacidad');
          }
          // Validar campos de texto
          else if (field.type !== 'checkbox' && !field.value.trim()) {
            isValid = false;
            const fieldName = field.type === 'textarea' ? 'mensaje' : 
                            field.id.includes('name') ? 'nombre' : 
                            field.id.includes('email') ? 'email' : 'campo';
            showFieldError(field, `El ${fieldName} es obligatorio`);
          }
          // Validar email
          else if (field.type === 'email' && field.value.trim()) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(field.value.trim())) {
              isValid = false;
              showFieldError(field, 'Por favor, introduce un email válido');
            }
          }
        });
        
        if (!isValid) {
          e.preventDefault();
          
          // Mostrar mensaje de error general
          const errorDiv = document.createElement('div');
          errorDiv.className = 'contact-form__error';
          errorDiv.innerHTML = `
            <svg class="icon icon-error" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="currentColor"/>
            </svg>
            <span>Por favor, completa todos los campos obligatorios correctamente.</span>
          `;
          
          const firstFormElement = contactForm.querySelector('.contact-form__field');
          if (firstFormElement) {
            contactForm.insertBefore(errorDiv, firstFormElement);
          } else {
            contactForm.prepend(errorDiv);
          }
          
          // Hacer scroll al primer error
          const firstInvalidField = contactForm.querySelector('[style*="border-color: #c00"]');
          if (firstInvalidField) {
            firstInvalidField.focus();
            firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
      
      // Función para mostrar error en un campo específico
      function showFieldError(field, message) {
        field.style.borderColor = '#c00';
        
        const fieldWrapper = field.closest('.contact-form__field');
        if (fieldWrapper) {
          const errorSpan = document.createElement('span');
          errorSpan.className = 'field-error';
          errorSpan.style.color = '#c00';
          errorSpan.style.fontSize = '13px';
          errorSpan.style.marginTop = '4px';
          errorSpan.textContent = message;
          fieldWrapper.appendChild(errorSpan);
        }
      }
      
      // Limpiar errores al cambiar los campos
      const inputs = contactForm.querySelectorAll('input, textarea');
      inputs.forEach(function(input) {
        input.addEventListener('input', function() {
          this.style.borderColor = '';
          const fieldWrapper = this.closest('.contact-form__field');
          if (fieldWrapper) {
            const fieldError = fieldWrapper.querySelector('.field-error');
            if (fieldError) {
              fieldError.remove();
            }
          }
          
          // Limpiar error general
          const generalError = contactForm.querySelector('.contact-form__error:not(.permanent)');
          if (generalError) {
            generalError.remove();
          }
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
